import './Screenshot.css'

import { FC, useMemo } from 'react'

import { GlobePointer } from '../../../components/Icons'
import { useScreenshot } from '../../../hooks/apiHooks/sessionHooks'
import type { VisualElement } from '../../../store/reducers/sessionReducer'
import { analytics } from '../../../utils/analytics'

const ScreenshotItem: FC<VisualElement> = ({ title, url, previewUrl }) => {
  const isYoutube = url.includes('youtube')

  const { data, isLoading } = useScreenshot(url, !isYoutube && !previewUrl)

  const youtubeUrl = useMemo(() => {
    const videoId = url.split('v=')[1]
    if (!isYoutube || !videoId || previewUrl) return null
    const ampersandPosition = videoId?.indexOf('&')
    if (videoId && ampersandPosition !== -1) {
      return videoId.substring(0, ampersandPosition)
    }
    return `https://i.ytimg.com/vi/${videoId}/sddefault.jpg`
  }, [url, isYoutube])

  const imgUrl = useMemo(() => {
    return data ? URL.createObjectURL(data) : ''
  }, [data])

  const handleClick = () => {
    analytics.logEvent('watch_session_visual_card_clicked', {
      type: isYoutube ? 'youtube' : 'web',
    })
  }

  return (
    <div className="relative w-full h-full text-white">
      <div className={`relative ${isLoading ? 'h-[320px]' : ''}`}>
        {(data || youtubeUrl || previewUrl) && (
          <>
            <img
              src={previewUrl || youtubeUrl || imgUrl}
              alt={title}
              className="w-full h-full object-cover rounded-lg"
            />
            {isYoutube && (
              <i className="fa-brands fa-youtube absolute  top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-4xl" />
            )}
          </>
        )}
      </div>
      <div className="p-4">
        <p className="mb-2 flex gap-2">
          {isYoutube ? (
            <i className="fa-brands fa-youtube mt-1" />
          ) : (
            <GlobePointer className="mt-1" />
          )}

          {title}
        </p>
        <div className="flex justify-center mt-4">
          <a
            href={url}
            target="blank"
            rel="noopener noreferrer"
            className=" bg-white text-black rounded-full p-2 px-4"
            onClick={handleClick}
          >
            <i className="fa-solid fa-up-right-from-square mr-2" />
            Learn more
          </a>
        </div>
      </div>
    </div>
  )
}

export { ScreenshotItem }
